import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { MsalAuthenticationTemplate, useIsAuthenticated } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '../authConfig';

const PrivateRoute = () => {
    const isSubaccount = localStorage.getItem("role_subaccount") === "true";
    const isAuthenticated = useIsAuthenticated();

    if (isAuthenticated && isSubaccount) {
        return <Navigate to="/unauthorised-access" />;
    }

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={loginRequest}
        >
            <Outlet />
        </MsalAuthenticationTemplate>
    );
};

export default PrivateRoute;